import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileImage.tsx
const IconFileImage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#b6c6f0",
			d: "M21 9v11.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1zm0-2h-5V2.003z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#6b91f2",
			fillRule: "evenodd",
			d: "M10 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m.333 1.25L7 17h10l-3.333-6L12 14.75z",
			clipRule: "evenodd"
		})
	]
});
var IconFileImage_default = forwardRef(IconFileImage);
//#endregion
export { IconFileImage_default as default };
